import AppError from "@/types/errors/app-error";

export default class CommandFailedError extends AppError {
    constructor(message: string, alert: string|null = null) {
        super(message, alert);
        this.name = "CommandFailedError";
    }
}